module.exports = __webpack_public_path__ + "static/media/regulatory.00bbba73.svg";